import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { RootState } from 'store';
import { MissionStatus } from 'store/progress';

type State = {
  isInitialize: boolean; // Suspenseと連動させるためのフラグ
  mission: number;
  missionStatus: MissionStatus | null;
};

const initialState: State = {
  mission: 0,
  isInitialize: false,
  missionStatus: null,
};

const baseUrl = process.env.REACT_APP_API_ENDPOINT || '';

// RTK Queryの設定
export const missionClearCardDataApi = createApi({
  reducerPath: 'missionClearCardDataApi',
  baseQuery: fetchBaseQuery({
    baseUrl,
    prepareHeaders: (headers, { getState }) => {
      // ここにカスタムヘッダーを追加します
      // 現在の状態にアクセスします
      const state = getState() as RootState;
      // 状態からユーザートークンを取得します
      const userToken = state.liffUser.userToken;
      headers.set('Content-Type', 'application/json');
      headers.set('Authorization', `Bearer ${userToken}`);
      return headers;
    },
  }),
  tagTypes: ['MissionClearCard'],
  endpoints: builder => ({
    postMissionClearCardData: builder.mutation<MissionStatus, { mission: number }>({
      query: ({ mission }) => ({
        url: `/mission-clear-card?mission=${mission}`,
        method: 'POST',
      }),
      invalidatesTags: ['MissionClearCard'],
    }),
  }),
});

// エンドポイント毎にカスタムhooksが作成される
export const { usePostMissionClearCardDataMutation } = missionClearCardDataApi;

const missionClearCard = createSlice({
  name: 'missionClearCard',

  initialState,

  reducers: {
    updateMission: (state, action: PayloadAction<number>) => {
      state.mission = action.payload;
    },
  },

  extraReducers: builder => {
    // POST後に状態を取得
    builder.addMatcher(
      missionClearCardDataApi.endpoints.postMissionClearCardData.matchFulfilled,
      (state, action: PayloadAction<MissionStatus>) => {
        console.log('POST mission-clear-card fulfilled');

        const missionStatus = action.payload;

        return {
          ...state,
          missionStatus,
          isInitialize: true,
        };
      }
    );
    // POST失敗
    builder.addMatcher(
      missionClearCardDataApi.endpoints.postMissionClearCardData.matchRejected,
      state => {
        console.error('POST mission-clear-card rejected');
      }
    );
  },
});

// Action Creators
export const { updateMission } = missionClearCard.actions;

// Reducer
export default missionClearCard.reducer;
